module.exports = __webpack_public_path__ + "static/6-b34f32b7a0fb03f04597d229eb94fe09.jpg";